// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8b9f9cbb","421":"b72b30b3","583":"c9155ddf","601":"6bdce3b8","808":"e407a1b7","891":"6f186468","918":"227908dd","978":"d8122b45"}[chunkId] + ".chunk.js";
};